// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCApiGatewayControllersModelsClsInboundSurveyDetail } from './tCApiGatewayControllersModelsClsInboundSurveyDetail.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsClsInboundSurvey {
    'surveyName'?: string | null;
    'surveyDetails'?: Array<TCApiGatewayControllersModelsClsInboundSurveyDetail> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsClsInboundSurvey>> = [
        {
            "name":     "surveyName",
            "baseName": "surveyName",
            "type":     "string"
        },
        {
            "name":     "surveyDetails",
            "baseName": "surveyDetails",
            "type":     "Array<TCApiGatewayControllersModelsClsInboundSurveyDetail>"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsClsInboundSurvey.attributeTypeMap;
    }
}
